const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.1 10.4l8.49-8.49a.996.996 0 011.41 0c.39.39.39 1.03 0 1.41l-8.49 8.49c-.98.98-1.46 2.25-1.46 3.53s.49 2.56 1.46 3.54c.98.98 2.25 1.46 3.54 1.46 1.28 0 2.56-.49 3.54-1.46l8.49-8.49c1.17-1.17 1.17-3.07 0-4.24a3 3 0 00-4.24 0l-8.49 8.49a.996.996 0 101.41 1.41l8.49-8.49a.996.996 0 011.41 0c.39.39.39 1.03 0 1.41l-8.49 8.49c-1.17 1.17-3.07 1.17-4.24 0a3 3 0 010-4.24l8.49-8.49c1.95-1.95 5.12-1.95 7.07 0s1.95 5.12 0 7.07L13 20.3a7.007 7.007 0 01-9.9 0c-2.73-2.74-2.73-7.17 0-9.9z"
});

const SvgFile = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file.295773b9.svg";
export { ForwardRef as ReactComponent };